<template>
  <div>
    <div id="moban" style="background: #F9F8F8;">
      <div class="daysign-con">
        <div class="daysign-left">
          <van-sidebar v-model="activeKey" :style="{width:'90%'}" @change="onChange">
            <van-sidebar-item
              :title="item.name"
              v-for="(item,index) in navList"
              :key="index"
              @click="handleMenulist(item,index)"
            />
          </van-sidebar>
        </div>
        <div class="daysign-right" v-if="hotImg">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              :offset="1"
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div class="list-img">
                <div v-for="(v,i) in personList" :key="i" class="show-pop list-img-w">
                  <div ref="canvasImgUrl">
                    <van-image lazy-load @click="drawPost(v,i)" :src="basurl+v.url">
                      <div class="pop-style" v-if="isShowUser">
                        <div class="item-center">
                          <div class="user-info">
                            <div>{{userInfo.realName}}</div>
                            <div>{{userInfo.phone}}</div>
                          </div>
                          <qrcode :staffId="id" :avatarName="userInfo.avatarName"></qrcode>
                        </div>
                      </div>
                    </van-image>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
        <div class="daysign-right" v-if="hotImgType">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              :offset="1"
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div class="list-img">
                <div v-for="(v1,i1) in imgTypeList" :key="i1" class="show-pop list-img-w">
                  <div ref="canvasImgUrl">
                    <van-image lazy-load @click="drawPost(v1,i1)" :src="basurl+v1.imageUrl">
                      <div class="pop-style" v-if="isShowUser">
                        <div class="item-center">
                          <div class="user-info">
                            <div>{{userInfo.realName}}</div>
                            <div>{{userInfo.phone}}</div>
                          </div>
                          <qrcode :staffId="id" :avatarName="userInfo.avatarName"></qrcode>
                        </div>
                      </div>
                    </van-image>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
    <van-popup v-model="show" :overlay="false" @close="closePop" closeable>
      <div class="pop-title">长按图片保存</div>
      <img class="save-img" :src="showImg" alt />
    </van-popup>
  </div>
</template>

<script>
import URL from "@/api/api";
import { Toast, Lazyload } from "vant";
import "swiper/swiper-bundle.min.css";
import qrcode from '../daySign/qrcode.vue';
import html2canvas from 'html2canvas'
// import { TextBounds } from 'html2canvas/dist/types/css/layout/text';
export default {
  components: { qrcode },
  data() {
    return {
      userInfo: {},
      showImg: null,
      id: null,
      realName: {},
      isShowUser: false,
      hotImg: true,
      hotImgType: false,
      dataType: null,
      personList: [],
      imgTypeList: [],
      loading: false,
      finished: false,
      refreshing: false,
      show: false,
      basurl: "https://zf.dtfcloud.com",
      pageNum: 1, //页数
      size: 3,//总条数
      total: 0,
      pageNum1: 1, //页数
      size1: 3,//总条数
      total1: 0,
      signImg: '',
      activeKey: 0,
      current: '',
      navList: [
        {
          name: '热门推荐',
          type: null
        },
        {
          name: '正能量',
          type: 'positiveEnergy'
        },
        {
          name: '节日',
          type: 'holiday'
        },
        {
          name: '早安',
          type: 'morning'
        },
      ]
    }
  },
  activated() {
    this.onLoad()
  },
  created() {
    this.getstaff()
  },
  methods: {
    // 关闭弹层
    closePop() {
      this.isShowUser = false
    },
    // 合成图片
    drawPost(v, e) {
      let that = this
      that.show = true
      that.isShowUser = true
      that.showImg = that.basurl + (v.url || v.imageUrl)
      Toast.loading({
        message: '加载中...',
        forbidClick: true, // 禁止背景点击
        duration: 0 // 持续展示
      })
      var opts = {
        useCORS: true, // 【重要】开启跨域配置
        scrollY: 0, // 纵向偏移量 写死0 可以避免滚动造成偶尔偏移的现象
        scrollX: 0,
        height: that.$refs.canvasImgUrl[e].offsetHeight - 8,
        width: that.$refs.canvasImgUrl[e].offsetWidth,
        scale: 8,
        dpi: window.devicePixelRatio * 2,
        backgroundColor: null,
      };
      setTimeout(() => {
        html2canvas(that.$refs.canvasImgUrl[e], opts).then(canvas => {
          that.showImg = canvas.toDataURL("image/jpeg");
          Toast.clear()
        });
      }, 500)
    },
    // 获取staffid
    getstaff() {
      this.userid = localStorage.getItem("userid")
      this.$fetchGet(URL.getStaffsCard.url, { userId: this.userid }).then((res) => {
        if (res.data.code == 20000) {
          this.id = res.data.data.id
          this.userInfo = res.data.data
        }
      })
    },
    onChange(n) {
      let that = this
      switch (n) {
        case 0:
          that.dataType = null
          break;
        case 1:
          that.dataType = 'positiveEnergy'
          break;
        case 2:
          that.dataType = 'holiday'
          break;
        case 3:
          that.dataType = 'morning'
          break;
        default:
          that.dataType = null
      }
    },
    getData(index) {
      let that = this
      let data = {
        page: that.pageNum,
        size: that.size
      }
      this.$fetchGet(URL.getSign.url, data).then((res) => {
        if (res.data.code == '20000') {
          //   this.list = res.data.data.url
          let list = res.data.data.records; //请求返回当页的列表
          that.refreshing = false;
          that.loading = false;
          Toast.clear()
          that.total = res.data.data.total;
          if (list == null || list.length === 0) {
            // 加载结束
            that.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          if (that.pageNum > 1) {
            that.personList = [...that.personList, ...list]
          } else {
            that.personList = list
          }
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.personList.length >= that.total) {
            that.finished = true;
          }
          // 如果总页数大于当前页码，页码+1
          if (that.size * that.pageNum < that.total) {
            that.pageNum++;
            if (index == 0) {
              that.getData(index)
            }
          }
        }
      });
    },
    handleMenulist(item, index, number, type) {
      let that = this
      if (!item.type) {
        that.pageNum = 1
        that.hotImgType = false
        that.hotImg = true
        that.getData(index)
        return
      }
      if (!number) {
        that.pageNum1 = 1
        that.imgTypeList = []
      }
      let data = {
        page: that.pageNum1,
        size: that.size1,
        type: type ? type : item.type
      }
      that.hotImg = false,
        that.hotImgType = true,
        this.$fetchGet(URL.getSignType.url, data).then((res) => {
          if (res.data.code == '20000') {
            //   this.list = res.data.data.url
            let list = res.data.data.records; //请求返回当页的列表
            if (item.type == 'holiday') {
              list.map((x, i) => {
                list[i].imageUrl = x.url
              })
            } else {
              list = res.data.data.records;
            }
            that.refreshing = false;
            that.loading = false;
            Toast.clear()
            that.total1 = res.data.data.total;
            if (list == null || list.length === 0) {
              // 加载结束
              that.finished = true;
              return;
            }
            // 将新数据与老数据进行合并
            if (that.pageNum1 > 1) {
              that.imgTypeList = [...that.imgTypeList, ...list]
            } else {
              that.imgTypeList = list
            }
            //如果列表数据条数>=总条数，不再触发滚动加载
            if (that.imgTypeList.length >= that.total1) {
              that.finished = true;
            }
            // 如果总页数大于当前页码，页码+1
            if (that.size1 * that.pageNum1 < that.total1) {
              that.pageNum1++;
              let number = 1
              that.handleMenulist(item, index, number)
            }
          }
        })
    },
    onRefresh() {

      let that = this
      if (that.hotImgType == true) {
        that.pageNum1 = 1
        that.handleMenulist('', '', '', that.dataType)
        return
      }
      that.finished = false;
      that.pageNum = 1
      that.loading = true;
      that.getData();
    },
    onLoad() {
      this.getData();
    },


  }
}
</script>

<style lang="less" scoped>
.item-content,
.title-name {
  font-size: 0.4rem;
}
.list-img {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
}
.list-img-w {
  width: calc(50% - 0.1rem);
  margin-right: 0.1rem;
}
.daysign-con {
  display: flex;
  .daysign-left {
    width: 25%;
  }
  .daysign-right {
    width: 75%;
    padding: 0.12rem 0.12rem 0 0;
  }
}
.show-pop {
  position: relative;
}
.van-image {
  /deep/ .pop-style {
    height: 1.1rem;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    bottom: 0.1rem;
    width: 95%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 5px;
    .item-center {
      height: 1.1rem;
      display: flex;
      justify-content: space-around;
      align-items: center;
      justify-items: center;
      .user-info {
        color: #fff;
        font-size: 10px;
        line-height: 1.2;
      }
    }
  }
}

.van-popup {
  width: 95%;
  height: 100%;
  img {
    width: 85%;
    display: block;
    margin: auto;
  }
}
.pop-title {
  height: 65px;
  font-size: 0.3rem;
  text-align: center;
  line-height: 60px;
}
</style>